/* 专利管理 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/patentManagement',
    // name: 'patentManagement',
    component: layoutComponent,
    meta: {
      title: 'menu.patentManagement',
      icon: 'el-icon-ali-PatentManagement'
    },
    children: [
      {
        path: '/patentManagement/patentListView',
        name: 'patentListView',
        component: () => import('@/views/patentManagement/patentListView.vue'),
        meta: {
          title: 'menu.patentManagement',
          buttons: [
            { code: 'scan', name: '浏览' },
            { code: 'add', name: '新增' },
            { code: 'delete', name: '删除' },
            { code: 'edit', name: '编辑' },
            { code: 'view', name: '查看' },
            { code: 'enable', name: '启用' },
            { code: 'disable', name: '禁用' },
            { code: 'import', name: '导入' }
          ]
        }
      },
      {
        path: '/patentManagement/patentAdd',
        name: 'patentAdd',
        component: () => import('@/views/patentManagement/patentAdd.vue'),
        meta: {
          title: 'menu.patentAdd',
          routeNameParent: 'patentListView'
        }
      },
      {
        path: '/patentManagement/patentEdit',
        name: 'patentEdit',
        component: () => import('@/views/patentManagement/patentEdit.vue'),
        meta: {
          title: 'menu.patentEdit',
          routeNameParent: 'patentListView'
        }
      },
      {
        path: '/patentManagement/patentView',
        name: 'patentView',
        component: () => import('@/views/patentManagement/patentView.vue'),
        meta: {
          title: 'menu.patentView',
          routeNameParent: 'patentListView'
        }
      },
      {
        path: '/patentManagement/patentListViewEmpower',
        name: 'patentListViewEmpower',
        component: () => import('@/views/patentManagement/patentListViewEmpower.vue'),
        meta: {
          title: 'menu.patentEmpower',
          buttons: [
            { code: 'view', name: '查看' },
            { code: 'assign', name: '分配' },
          ]
          
        }
      },
      {
        path: '/patentManagement/patentListViewEmpowerdetail',
        name: 'patentListViewEmpowerdetail',
        component: () => import('@/views/patentManagement/patentListViewEmpowerdetail.vue'),
        meta: {
          title: 'menu.privilegeManagement',
          routeNameParent: 'patentListViewEmpower'
        }
      },
    ]
  }

]
